export default {
	client: [
		{
			url: "/orders",
			name: "orders",
			slug: "orders",
			icon: "ClipboardIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
		},
	],
	author: [
		{
			url: "/exchange",
			name: "exchangePageName",
			slug: "exchange",
			icon: "RepeatIcon",
			tag: "notification/get-works-notification-count"
		},
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
			tag: "notification/get-orders-notification-count"
		},
		{
			url: "/tasks",
			name: "tasks",
			slug: "tasks",
			icon: "CalendarIcon",
			tag: "notification/get-tasks-notification-count"
		},
		{
			url: "/stats",
			name: "statistics",
			slug: "statistic",
			icon: "PieChartIcon",
		},
		{
			url: "/finance",
			name: "finances",
			slug: "finance",
			icon: "CreditCardIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
		},
		{
			url: "/guides",
			name: "policiesAndGuides",
			slug: "guides",
			icon: "HelpCircleIcon",
		},
	],
	manager: [
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
			tag: "notification/get-orders-notification-count"
		},
		{
			url: "/tasks",
			name: "tasks",
			slug: "tasks",
			icon: "CalendarIcon",
			tag: "notification/get-tasks-notification-count"
		},
		{
			url: "/clientsM",
			name: "clients",
			slug: "clients",
			icon: "UsersIcon",
			tag: "notification/get-clients-notification-count"
		},
		// {
		// 	url: "/authors",
		// 	name: "authors",
		// 	slug: "authors",
		// 	icon: "Edit3Icon",
		// },
		{
			url: "/finance",
			name: "finances",
			slug: "finance",
			icon: "CreditCardIcon",
		},
		{
			url: "/stats",
			name: "statistics",
			slug: "stats",
			icon: "PieChartIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
		},
		{
			url: "/guides",
			name: "policiesAndGuides",
			slug: "guides",
			icon: "HelpCircleIcon",
		},
	],
	admin: [
		{
			url: "/exchange",
			name: "exchangePageName",
			slug: "exchange",
			icon: "RepeatIcon",
		},
		{
			url: "/tickets",
			name: "tickets",
			slug: "tickets",
			icon: "FileTextIcon",
			tag: "notification/get-orders-notification-count"
		},
		{
			url: "/tasks",
			name: "tasks",
			slug: "tasks",
			icon: "CalendarIcon",
			tag: "notification/get-tasks-notification-count"
		},
		{
			url: "/quality-assurance",
			name: "qualityAssurance",
			slug: "qualityAssurance",
			icon: "CheckIcon"
		},
		{
			url: "/managers",
			name: "managers",
			slug: "managers",
			icon: "GridIcon",
		},
		{
			url: "/logs",
			name: "logs",
			slug: "logs",
			icon: "ActivityIcon",
		},
		{
			url: "/clients",
			name: "clients",
			slug: "clients",
			icon: "UsersIcon",
			tag: "notification/get-clients-notification-count"
		},
		{
			url: "/authors",
			name: "authors",
			slug: "authors",
			icon: "Edit3Icon",
			tag: "notification/get-authors-notification-count"
		},
		{
			url: "/sites",
			name: "sites",
			slug: "sites",
			icon: "GlobeIcon",
		},
		// {
		// 	url: "/finance",
		// 	name: "finances",
		// 	slug: "finance",
		// 	icon: "CreditCardIcon",
		// 	tag: "notification/get-payouts-notification-count"
		// },
		{
			url: "/stats",
			name: "statistics",
			slug: "stats",
			icon: "PieChartIcon",
		},
		{
			url: "/typeWorks",
			name: "workTypes",
			slug: "typeWorks",
			icon: "BriefcaseIcon",
		},
		{
			url: "/templates",
			name: "templateAnswers",
			slug: "templates",
			icon: "CheckIcon",
		},
		{
			url: "/support",
			name: "techSupportShort",
			slug: "support",
			icon: "MailIcon",
			tag: "notification/get-support-notification-count"
		},
		{
			url: "/guides",
			name: "policiesAndGuides",
			slug: "guides",
			icon: "HelpCircleIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
	],
	accountant: [
		{
			url: "/finance",
			name: "finances",
			slug: "finance",
			icon: "CreditCardIcon",
		},
		{
			url: "/profile",
			name: "profile",
			slug: "profile",
			icon: "EditIcon",
		},
	]

}
